import {get, post, put} from "./utils"
import exp from "constants";

export interface Field {
    type: string
    title: string
    value_empty_behavior: string
}

export interface ObjectSchema {
    name: string
    slug: string
    title: string
    many: boolean
    fields: Record<string, Field>
}

export function IsCrawlSchema(schema: ObjectSchema): boolean {
    for (const key in schema.fields) {
        if (!key.startsWith("crawl")) {
            return false
        }
    }

    return true
}

export interface ParserField {
    type: string
    xpath: Array<string>
    title?: string

    // postprocessing
    date_template?: string | null
    value_empty_behavior?: string;
}

export interface ParserConfig {
    fields: Record<string, ParserField>
    item_block_xpath: string | null
}

export interface PageType {
    id: number
    name: string
    site_name: string
    configs: Record<string, ParserConfig>
}

export async function saveObjectConfig(schema: string, pageTypeID: number, config: ParserConfig): Promise<void> {
    await put(`/api/page/${pageTypeID}/schema/${schema}`, {
        config: config,
    })
}

export async function getSchemas(siteID: number): Promise<Record<string, ObjectSchema>> {
    const schemas = (await get<{ schemas: ObjectSchema[] }>(`/api/site/${siteID}/schemas`)).schemas;

    const ret: Record<string, ObjectSchema> = {}
    for (const schema of schemas) {
        ret[schema.slug] = schema
    }

    return ret
}

export async function listPageTypes(siteID: number): Promise<Record<number, PageType>> {
    const pageTypes = (await get<{ resp: PageType[] }>(`/api/site/${siteID}/pages`)).resp;

    const ret: Record<number, PageType> = {}
    for (const pageType of pageTypes) {
        ret[pageType.id] = pageType
    }

    return ret
}

interface StartUrl {
    url: string
    page_type_id: number
}

export async function putStartUrls(siteID: number, startUrls: StartUrl[]): Promise<void> {
    await put<any, any>(`/api/site/${siteID}/start_urls`, {
        urls: startUrls,
    })
}


// export async function getProxyList(): Promise<string> {
//
// }
